export default "__VITE_ASSET__c300be3c__"